import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { HelpCircle } from "lucide-react";
import { getDocsHelpPath } from "../../utils/docUtils/docsHelpMap";
import helpStyles from "../../styles/docs/helpLink.module.scss";

const DocsHelpLink = () => {
  const activePage = useSelector((state) => state.navigation.activePage);
  const helpPath = getDocsHelpPath(activePage);

  return (
    <Link
      to={helpPath}
      target="_blank"
      rel="noopener noreferrer"
      className={helpStyles.helpLink}
    >
      <HelpCircle size={16} className={helpStyles.helpIcon} aria-hidden="true" />
      <span>Help</span>
    </Link>
  );
};

export default DocsHelpLink;
